import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProfileList } from '@modules/front-office/interface/fo-profile-interface.ts';

const initialState: ProfileList[] = [];

export const ACCGCustomerSlice = createSlice({
  name: 'accgCustomer',
  initialState,
  reducers: {
    setACCGCustomer: (_state, action: PayloadAction<ProfileList[]>) => {
      return [...action.payload];
    },
    removeACCGCustomer: () => {
      return initialState;
    },
  },
});

export default ACCGCustomerSlice.reducer;

export const { setACCGCustomer, removeACCGCustomer } =
  ACCGCustomerSlice.actions;
